import { Observable } from 'rxjs';
import { ParametrizationRepository } from '../domain/parameters/repository';

import HttpClient from '../utils/http-client';

export class ParametrizationRepositoryImplementation extends ParametrizationRepository {
  getParametrization(uid: string, cid: string | null): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.get<any>(`/accounting/parametrization`);
  }

  setParametrization(uid: string, cid: string | null, data: any): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.post<any>(`/accounting/parametrization`, data);
  }

  setParametrizationBatch(uid: string, cid: string | null, items: any[]): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.patch<any>(`/accounting/parametrization/batch`, { items });
  }



  getParametrizationTypes(uid: string, cid: string | null): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.get<any>(`/accounting/parametrization-types`);
  }
}
